import React from 'react';
import styled from 'styled-components';

import { BREAK_POINTS, Colors, Metrics } from '@origin-digital/style-guide';

export const Container = styled.div`
  background-color: ${Colors.GREY4};
  min-height: calc(100vh - 128px);
  box-sizing: border-box;
  position: relative;
`;

export const Content = styled.div`
  padding: 16px;
  margin: 0 auto;

  & > * {
    margin-bottom: 24px;
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    padding: 32px 0;
    width: 540px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 64px 0;
    width: 724px;
  }
`;

export const Heading = styled.h2`
  font-size: 24px;
  line-height: 40px;
  color: ${Colors.GREY56};
  margin-top: 0;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    font-size: 32px;
  }
`;

export const ContentText = styled.p`
  padding: 0;
  font-size: 14px;
  line-height: 24px;
  margin-top: 0;
  color: ${Colors.GREY};
`;

export const InlineSelect = styled.div`
  display: inline-block;
  [data-id='selectField'] {
    display: inline-block;
    select {
      border: none;
      font-weight: ${Metrics.FontWeights.MEDIUM};
      text-decoration: underline;
      padding-right: 24px;
    }
    & > div {
      &:first-child {
        margin-bottom: 0;
      }
      & > div {
        width: auto;
        & > div:first-child {
          height: auto;
          background: none;
          label + div {
            top: 50%;
            right: 0;
            bottom: unset;
            transform: translateY(-50%);
            width: auto;
            height: auto;
            svg {
              color: ${Colors.RED};
            }
          }
          & > div:last-child {
            display: none;
          }
        }
        & > div:last-child {
          display: none;
        }
      }
    }
  }
  select {
    padding: 0;
    margin: 0;
    width: auto;
    font-size: 14px;
    color: ${Colors.RED};
    &:focus {
      width: auto;
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  opacity: 0.5;
  background: white;
  z-index: 1001;
  & > * {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
